import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-light" dir="rtl">
      <div className="text-center p-6 bg-white rounded-lg shadow-lg w-full max-w-md">
        <h1 className="text-6xl text-danger font-bold mb-4">404</h1>
        <p className="text-xl text-muted mb-6">عذرًا! الصفحة التي تبحث عنها غير موجودة.</p>
        <Link
          to="/"
          className="text-primary text-lg font-semibold hover:underline transition duration-300"
        >
          العودة إلى الصفحة الرئيسية
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
